import { Box } from '@mui/material';
import React from 'react';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';

const StarsDisplay = ({ value }) => {

    const starsMapping = {
        one: 1,
        two: 2,
        three: 3,
        four: 4,
        five: 5
    };

    const numberOfStars = starsMapping[value?.toLowerCase()] || 0;

    return (
        <Box style={{ display: 'flex', alignItems: 'center' }}>
            {Array.from({ length: 5 }, (_, index) => (
                index < numberOfStars ? (
                    <StarIcon
                        key={index}
                        style={{ color: '#FFD700' }}
                    />
                ) : (
                    <StarBorderIcon
                        key={index}
                        style={{ color: '#D1D5DB' }}
                    />
                )
            ))}
        </Box>
    );
};

export default StarsDisplay;